import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectHomepage, setOpenModal } from '@/redux/state/homepage';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, Col, Container, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { ChosenBookingTimeCard, ChosenContactMethodCard, ChosenSpecialtyCard } from './Cards/ChosenCards';
import { ExampleCard } from './Cards/Listing';
import './Mobile/PickServiceMobile.scss';
import './PickService.scss';



const bookLawyer_t_prefix = "pages.homePage.bookLawyer";
const pickService_t_prefix = "pages.homePage.pickService";

interface PickServiceContainerProps {
    children: any
    styleId: "pick-service" | "pick-service-mobile"
    styles?: React.CSSProperties
}
const PickServiceContainer: React.FC<PickServiceContainerProps> = ({ children, styleId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [iconTabs, _] = React.useState(null);
    const { choices } = useAppSelector(selectHomepage);
    const { openModals: { specialty, contactMethod, bookingTime }} = useAppSelector(selectHomepage);
    const { specialty: chosenSpecialty, contactMethod: chosenContactMethod, bookingTime: chosenBookingTime, clientReservation } = choices

    const toggleSpecialtyModal = (isOpen: boolean) =>
        dispatch(setOpenModal({ modal: "specialty", isOpen }));
    const toggleContactMethodModal = (isOpen: boolean) =>
        dispatch(setOpenModal({ modal: "contactMethod", isOpen }));
    const toggleBookingTimeModal = (isOpen: boolean) =>
        dispatch(setOpenModal({ modal: "bookingTime", isOpen }));

    const isContactMethodDisabled = () => chosenSpecialty ? false : true;
    const isBookingTimeDIsabled = () => chosenSpecialty && chosenContactMethod ? false : true;

    const contactBtnClass = isContactMethodDisabled() ? 'disabled-selection' : ''
    const bookingBtnClass = isBookingTimeDIsabled() ? 'disabled-selection' : ''

    return (
        <>
            <Container id={styleId} className="tabs">
                <Row className="row-card">
                    <Col className="tabs-box" md="10" xl="6">
                        <Card style={{ marginTop: 0 }}>
                            <CardHeader>
                                <Nav className="justify-content-around" role="tablist" tabs>
                                    <NavItem>
                                        <NavLink
                                            className={
                                                iconTabs === "specialty"
                                                    ? "active tabby"
                                                    : "tabby unselected"
                                            }
                                            onClick={(e) => toggleSpecialtyModal(!specialty)}
                                        >
                                            <FontAwesomeIcon icon={faScaleBalanced} />
                                            <div className="icon-description">
                                                <h5 style={{ margin: 0 }}>
                                                    {t(`${bookLawyer_t_prefix}.inputs.specialty`)}
                                                </h5>
                                                <span className="tab-description"></span>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={
                                                iconTabs === "contactMethod"
                                                    ? `active tabby ${contactBtnClass}`
                                                    : `tabby unselected ${contactBtnClass}`
                                            }
                                            onClick={(e) => toggleContactMethodModal(!contactMethod)}
                                            disabled={isContactMethodDisabled()}
                                        >
                                            <i className="now-ui-icons ui-2_chat-round"></i>
                                            <div className="icon-description">
                                                <h5 style={{ margin: 0 }}>
                                                    {t(`${pickService_t_prefix}.contactMethod`)}
                                                </h5>
                                                <span className="tab-description"></span>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={
                                                iconTabs === "bookingTime"
                                                    ? `active tabby ${bookingBtnClass}`
                                                    : `tabby unselected ${bookingBtnClass}`
                                            }
                                            onClick={(e) => toggleBookingTimeModal(!bookingTime)}
                                            disabled={isBookingTimeDIsabled()}
                                        >
                                            <i className="now-ui-icons ui-1_calendar-60"></i>
                                            <div className="icon-description">
                                                <h5 style={{ margin: 0 }}>
                                                    {t(`${pickService_t_prefix}.bookingTime`)}
                                                </h5>
                                                <span className="tab-description"></span>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </CardHeader>
                            {children}
                        </Card>
                    </Col>
                </Row>
                <Row xs="1" md="1" lg="2" xl="2" style={{alignItems: "center"}}>
                    <Col>
                        {chosenSpecialty && (
                            <ChosenSpecialtyCard />
                        )}
                        {chosenContactMethod && (
                            <ChosenContactMethodCard />
                        )}
                        {chosenBookingTime && (
                            <ChosenBookingTimeCard />
                        )}
                    </Col>
                    <Col>
                        {clientReservation?.assignedLawyer.id && <ExampleCard />}
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PickServiceContainer;
